module.exports = __webpack_public_path__ + "static/media/27.2cf58e12.jpg";